__turbopack_context__.v({
  "dark": "styles-module-scss-module__ebwQrG__dark",
  "divider": "styles-module-scss-module__ebwQrG__divider",
  "light": "styles-module-scss-module__ebwQrG__light",
  "root": "styles-module-scss-module__ebwQrG__root",
  "text": "styles-module-scss-module__ebwQrG__text",
});
